export default __webpack_public_path__ + "static/media/loader-ring.3d9bf093.svg";